import { render, staticRenderFns } from "./addScreen.vue?vue&type=template&id=200f1ba9&scoped=true&"
import script from "./addScreen.vue?vue&type=script&lang=js&"
export * from "./addScreen.vue?vue&type=script&lang=js&"
import style0 from "./addScreen.vue?vue&type=style&index=0&id=200f1ba9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f1ba9",
  null
  
)

export default component.exports